import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaPinterestP, FaLinkedinIn, FaInstagram, FaEnvelope } from 'react-icons/fa';
import { FiSend } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log(`Subscribing email: ${email}`);
    setEmail('');
    // Show success message here
  };

  return (
    <footer className="footer">
      <div className="contai">
        <div className="footer-top">
          <div className="footer-columns">
            <div className="footer-column newsletter-column">
              <div className="footer-heading">
                <FaEnvelope className="footer-icon" />
                <h3 className="footer-title">Get Latest Updates</h3>
              </div>
              <p className="footer-text">
                It only takes a second to be the first to find out about our latest news and promotions...
              </p>
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <div className="form-group">
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="btn-subscribe">
                    <FiSend className="btn-icon" />
                    SIGN UP
                  </button>
                </div>
              </form>
            </div>

            <div className="footer-column social-column">
              <div className="footer-heading">
                <div className="social-icon-circle">
                  <FaFacebookF className="footer-icon" />
                </div>
                <h3 className="footer-title">Follow Us</h3>
              </div>
              <p className="footer-text">
                Connect with us on social media for the latest updates
              </p>
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaFacebookF className="social-icon" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaTwitter className="social-icon" />
                </a>
                <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaPinterestP className="social-icon" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaLinkedinIn className="social-icon" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaInstagram className="social-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} PrimeCare Pharmacy . All rights reserved.</p>
            </div>
            <div className="payment-methods">
              <img
                src="https://ext.same-assets.com/3505992194/1788181171.png"
                alt="Payment Methods"
                className="payment-icons"
              />
            </div>
            </div>
          </div>
        </div>
    </footer>
  );
};

export default Footer;